<template>
  <div class="admin-page">
    <div v-if="!isAdmin" class="permission-denied">
      <el-result
        icon="warning"
        title="权限不足"
        sub-title="您需要管理员权限才能访问此页面"
      >
        <template #extra>
          <el-button type="primary" @click="$router.push('/knowledge/courses')">
            返回课程页面
          </el-button>
        </template>
      </el-result>
    </div>
    <KnowledgePointAdmin v-else :initial-kc-id="initialKcId" />
  </div>
</template>

<script>
import KnowledgePointAdmin from './components/KnowledgePointAdmin.vue'
import { isSystemAdmin } from '@/utils/sysRole'

export default {
  name: 'KnowledgePointsView',
  components: {
    KnowledgePointAdmin
  },
  computed: {
    initialKcId() {
      return this.$route.query.kcId || null
    }
  },
  data() {
    return {
      isAdmin: false
    }
  },
  created() {
    this.checkAdminPermission()
  },
  methods: {
    checkAdminPermission() {
      const userInfo = localStorage.getItem('user_info')
      if (userInfo) {
        const user = JSON.parse(userInfo)
        this.isAdmin = isSystemAdmin(user.sysRole)
      }
    }
  }
}
</script>
